import { ApiParameter, post, request, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface SelectCustomConfigApiParameter extends ApiParameter {
    customOrderParams: Partial<SelectCustomConfigApiModel>;
}

export interface SelectCustomConfigApiModel extends ApiParameter {
    uri: string;
    productNumber: string;
    shape: string;
    widthFeet: number;
    widthInches: number;
    lengthFeet: number;
    lengthInches: number;
    sideFeet: number;
    sideInches: number;
    diameterFeet: number;
    diameterInches: number;
    poNumber: string;
    sidemark: string;
    quantity: number;
    description: string;
    price: string;
    customSize: string;
    leadTime: string;
    comment: string;
    signature: string;
    isTermAgreed: boolean;
    quoteDate: Date | string;
}
const customUrl = "/api/v2/requestquote";

export async function CustomConfigService(parameter: SelectCustomConfigApiParameter) {
    const response = await post<SelectCustomConfigApiParameter>(customUrl, parameter);
    return response;
}
